import {Packages} from "@js/api/packages";

export class Ajax {
    static Packages = Packages;
}
